import React, { Component } from "react";
import axios from 'axios'; 
import Serverurl from './Apiurl';


import Button from '@mui/material/Button';

import CloseIcon from '@mui/icons-material/Close'; 
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { Map, GoogleApiWrapper, Marker,InfoWindow  } from 'google-maps-react';
import Mapautocomplete from "./Mapautocomplete";
const mapStyles = {
  width: '100%',
  height: '400px'
};



 class  CustomerAddress extends Component {

   constructor(props) {
      super(props)
	 
      this.state = {
		  previocn:'',
		   open:false,name:'',ad_buildingdetails:'',ad_address:'',ad_cs_id:'',ad_id :'',
      errormessage:'',erropen:false,btndisabled:'',bnid:'',
submitbtn:"Save",latitude:"", longitude:'', 
	 
	  markers: [
        {
          title: "The marker`s title will appear as a tooltip.",
          name: "SOMA",
          position: { lat: 	12.971599, lng: 77.594566 }
        }
      ]
	  }
       this.onClick = this.onClick.bind(this); 
  }
  
   componentWillMount() {
	   this.Getgooglemap();
   }
  Getgooglemap(){
	   let self=this;
	 
	   if(this.props.lat=="")
	   {
	   if ("geolocation" in navigator) {
       navigator.geolocation.getCurrentPosition(function(position) {
		   
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
	  self.setState({latitude:position.coords.latitude,longitude:position.coords.longitude,loading:'',
	  
	   markers: [
        {
          
          position: { lat:position.coords.latitude, lng: position.coords.longitude }
        } ]
	  });
	  
	   
    });
    }
	   }else{
self.setState({latitude:this.props.lat,longitude:this.props.lng, 
	   markers: [
        {
          
          position: { lat:this.props.lat, lng: this.props.lng }
        } ]});
	   }		   
   }
 
setlatlng = (e) => {

alert('1')
}

  onMarkerClick = (props, marker, e) =>{
 
 
	}
	onClose = props => {
    
  };
    onMapClicked = (props) => {
		 if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
    
  };
   onClick(t, map, coord) {
	   var self=this;
	   self.setState({ad_address:'11'}); 
    const { latLng } = coord;
	   const lat = latLng.lat();
    const lng = latLng.lng();
	
	let formatadrs="";
	 var latlng = new window.google.maps.LatLng(parseFloat( lat), parseFloat(lng));
	var geocoder =  new window.google.maps.Geocoder();
 
            var address;
            geocoder.geocode({ 'latLng': latLng }, function (results, status) {
                
                    if (status == "OK") {             
                    
formatadrs=results[0].formatted_address;
   
              self.setState({ad_address:formatadrs,latitude:lat,longitude:lng,}); 
 self.props.parentCallback(lat+ "~" +lng+"~"+formatadrs);        
/*self.props.parentcalladdress(
lat+"~"+lng+"~"+formatadrs
);	*/		  
                }
            });
 this.setState(previousState => {
      return {
        markers: [
        
          {
            title: "",
            name: "",
            position: { lat, lng }
          }
        ]
      };
    });
    
	
  }
   handleCallback = (childData) => {
         let self=this;
	var strvalues=childData.split('~');
	const lat = strvalues[0];
    const lng = strvalues[1];
	
	/*self.props.parentcalladdress(
strvalues[0]+"~"+strvalues[1]+"~"+strvalues[2]
);*/
	
	 this.setState({latitude:lat,longitude:lng,ad_address:strvalues[2]});
    this.setState(previousState => {
      return {
        markers: [
        
          {
            title: "",
            name: "",
            position: { lat, lng }
          }
        ]
      };
    },()=>{
		
		  navigator.geolocation.getCurrentPosition(function(position) {
		 self.setState({ markers: [
        {
          
          position: { lat:lat, lng:lng }
        } ]});
		  });
		
	});
        
    }



render (){

return(
<React.Fragment>





   

		
			  
	 
		 
		<div style={{ height: '415px', width: '100%',position:'relative' }}>
 {(this.state.latitude==='' ) &&(
  <h4>Loading...</h4>
 )}
 {(this.state.latitude!=='' ) &&(
        <Map
          google={this.props.google}
          zoom={this.state.zoom}  onClick={this.onClick}
          style={mapStyles} onLoad={this.Getgooglemap}
		   defaultCenter={{lat: this.state.latitude, lng:  this.state.longitude}}
          initialCenter={{
            lat: this.state.latitude,
            lng: this.state.longitude
          }}
        >
		
		
		 {this.state.markers.map((marker, index) => (
            <Marker
              key={index}
              title={marker.title}
              name={marker.name}
              position={marker.position}
            />
          ))}
        
		
        </Map>)}
		
		
</div>
		
		
		
        
	

	
	







</React.Fragment>

) }
 
}export default GoogleApiWrapper({
  apiKey: 'AIzaSyC8h_mvGDzcKMbco8ouhimrHCXQEQpc--M'
})(CustomerAddress);






